export const paginationSx = {
  '& .Mui-selected': {
    color: 'var(--pagination-item-color)'
  },
  '& .MuiPaginationItem-root': {
    color: 'var(--pagination-item-color)'
  }
};

